import { SortOptions } from '~src/spacesPlatform/models/sort/CommonSortOptions';
import { Order } from '~src/spacesPlatform/models/sort/Order';
import { OptionsDictionary } from '~src/spacesPlatform/models/sort/SortOptionDefinitions';

import { Messages } from '../../../codegen/Localize';
import { OrderKeys } from '../../../spacesPlatform/models/OrderKeys';

export const subscriptionSortOptions: OptionsDictionary = {
  'user': {
    id: OrderKeys.userDisplayName,
    getMenuItemDisplayValue: Messages.username,
    subSortOptions: {
      'asc': {
        id: 'user.asc',
        field: OrderKeys.userDisplayName,
        getMenuItemDisplayValue: Messages.sortByAZ,
        ascending: true,
        toOrderClauseArray: () => [Order.asc(OrderKeys.userDisplayName)]
      },
      'desc': {
        id: 'user.desc',
        field: OrderKeys.userDisplayName,
        getMenuItemDisplayValue: Messages.sortByZA,
        ascending: false,
        toOrderClauseArray: () => [Order.desc(OrderKeys.userDisplayName)]
      }
    }
  },
  'subject': {
    id: OrderKeys.subject,
    getMenuItemDisplayValue: Messages.column_task_subject,
    subSortOptions: {
      'asc': {
        id: 'subject.asc',
        field: OrderKeys.subject,
        getMenuItemDisplayValue: Messages.sortByAZ,
        ascending: true,
        toOrderClauseArray: () => [Order.asc(OrderKeys.subject)]
      },
      'desc': {
        id: 'subject.desc',
        field: OrderKeys.subject,
        getMenuItemDisplayValue: Messages.sortByZA,
        ascending: false,
        toOrderClauseArray: () => [Order.desc(OrderKeys.subject)]
      }
    }
  },
  'targetName': {
    id: OrderKeys.targetName,
    getMenuItemDisplayValue: Messages.column_task_subscription,
    subSortOptions: {
      'asc': {
        id: 'targetName.asc',
        field: OrderKeys.targetName,
        getMenuItemDisplayValue: Messages.sortByAZ,
        ascending: true,
        toOrderClauseArray: () => [Order.asc(OrderKeys.targetName)]
      },
      'desc': {
        id: 'targetName.desc',
        field: OrderKeys.targetName,
        getMenuItemDisplayValue: Messages.sortByZA,
        ascending: false,
        toOrderClauseArray: () => [Order.desc(OrderKeys.targetName)]
      }
    }
  },
  'schedule' : SortOptions.schedule,
  'creatorName': {
    id: OrderKeys.creatorName,
    getMenuItemDisplayValue: Messages.column_task_subscribed_by,
    subSortOptions: {
      'asc': {
        id: 'creatorName.asc',
        field: OrderKeys.creatorName,
        getMenuItemDisplayValue: Messages.sortByAZ,
        ascending: true,
        toOrderClauseArray: () => [Order.asc(OrderKeys.creatorName)]
      },
      'desc': {
        id: 'creatorName.desc',
        field: OrderKeys.creatorName,
        getMenuItemDisplayValue: Messages.sortByZA,
        ascending: false,
        toOrderClauseArray: () => [Order.desc(OrderKeys.creatorName)]
      }
    }
  },
  'lastSentAt': {
    id: OrderKeys.lastSentAt,
    getMenuItemDisplayValue: Messages.column_task_last_update,
    subSortOptions: {
      'asc': {
        id: 'lastSentAt.asc',
        field: OrderKeys.lastSentAt,
        getMenuItemDisplayValue: Messages.sortByAZ,
        ascending: true,
        toOrderClauseArray: () => [Order.asc(OrderKeys.lastSentAt)]
      },
      'desc': {
        id: 'lastSentAt.desc',
        field: OrderKeys.lastSentAt,
        getMenuItemDisplayValue: Messages.sortByZA,
        ascending: false,
        toOrderClauseArray: () => [Order.desc(OrderKeys.lastSentAt)]
      }
    }
  },
  'runNextAt' : SortOptions.runNextAt,
  'siteName'  : SortOptions.siteName
};
